/**
 * Function for tags toggle, expand or hide tags.
 * Show 5 tags by default.
 */
 const showMoreToggle = document.getElementById("showMoreToggle");
 const tags = document.querySelector(".c-button-list__list");
 
    if (tags !== null){
        const tagItems = tags.querySelectorAll(".js-tag-toggle");
        let tagArr = []
        let tagArrRest = []
        if (tagItems !== null) {
            tagItems.forEach(tagItem => {
                tagArr.push(tagItem)
            });
        }
        let click = true;
        tagArrRest = tagArr.slice(5, tagArr.length);
        /**
         * by default 
         * hide all in tagArrRest
         */
        tagArrRest.forEach(item => {
            item.classList.add('hidden')
        })
        /**
         * function  to show all tags
         */
        if(showMoreToggle !== null){
         showMoreToggle.addEventListener("click", function(e) {
        
            tagArrRest.forEach(item => {
                        item.classList.toggle('hidden')
             })
                if (click) {
                this.innerText = "Show less";
                click = false;
                
                } else {
                this.innerText = "Show more";
                click = true;
                }
            
         });
        }
    }